import { render, staticRenderFns } from "./GroupMemberTable.html?vue&type=template&id=31aaad90&"
import script from "./GroupMemberTable.js?vue&type=script&lang=js&"
export * from "./GroupMemberTable.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports